
import { Component, Vue, Watch } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { TOnboarding } from "@/models/compliance_onboarding";
import { SMQuestionnaire, SMUser } from "@/store";

import ChatIcon from "@/assets/images/icons/chat-icon.svg";

import { NOTIFICATION_PROPS_ERROR } from "@/constants/notification";
import { COMPLETED_TASK_STATUS, TO_DO_TASK_STATUS } from "@/constants/tasks";

const TASKS_PATH = "/employer/tasks";
const GUIGE_PATH = "/employer/guide/41";

@Component({
  components: {
    EnumBlock: () => import("@/modules/Compliance/Blocks/EnumBlock.vue"),
    NotificationTemplate: () =>
      import("@/components/NotificationTemplate/NotificationTemplate.vue"),
  },
})
export default class Compliance extends Vue {
  notificationProps = NOTIFICATION_PROPS_ERROR;

  chatIcon = ChatIcon;

  init = false;

  onboarding: TOnboarding = {
    show: false,
    complete_company_profile_task: { id: 0, status: "" },
    upload_company_documents_task: { id: 0, status: "" },
    complete_the_monthly_checklist_task: { id: 0, status: "" },
    invite_employee_task: false,
    do_the_right_to_work_check_task: { id: 0, status: "" },
    provide_employment_data_and_documents_task: { id: 0, status: "" },
  };

  get needsUpdate() {
    return SMQuestionnaire.needsUpdate;
  }

  @Watch("needsUpdate", { immediate: true })
  async needsUpdateChanged(val: boolean) {
    if (!val) return;

    await this.fetchOnboarding();
  }

  get isComplianceBlocked() {
    return SMUser.user?.is_compliance_blocked;
  }

  get inviteEmployeeTaskStatus() {
    return this.onboarding.invite_employee_task ? COMPLETED_TASK_STATUS : TO_DO_TASK_STATUS;
  }

  async mounted() {
    await this.fetchOnboarding();
  }

  async fetchOnboarding() {
    try {
      const { data } = await this.axios.get<TOnboarding>(API_ROUTES.COMPLIANCE_ONBOARDING);

      if (!data) return;

      this.onboarding = { ...data };
    } finally {
      this.init = true;
    }
  }

  async openTask(id: number) {
    if (!id) return;

    await this.$router.push(`${TASKS_PATH}/${id}`);
  }

  async openGuide() {
    await this.$router.push(GUIGE_PATH);
  }

  async onboardEmployee() {
    if (this.isComplianceBlocked) return;

    const { data } = await this.axios.get(API_ROUTES.COMPANY_EMPLOYEE_ONBOARD_EMPLOYEE);

    const { task_id } = data;

    await this.$router.push(`${SMUser.basePath}/tasks/${task_id}`);
  }
}
